import { render, staticRenderFns } from "./ContentEditor.vue?vue&type=template&id=c70a708e&"
import script from "./ContentEditor.vue?vue&type=script&lang=js&"
export * from "./ContentEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports